module.exports = __webpack_public_path__ + "static/media/2024_2025_UIL_Region_20_Judges.df42d91a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/24-25/2024_2025_UIL_Region_20_Judges.pdf
// module id = 237
// module chunks = 0